import { oc } from '@orpc/contract';
import { getKpiInputSchema, kpiDetailSchema } from '../schemas/kpis.schemas.js';
export const getKpiContract = oc
    .route({
    method: 'GET',
    path: '/kpis/{id}',
    tags: ['KPIs'],
    summary: 'Get one KPI with its delete/deactivate guards; 404 outside the caller’s pillars',
})
    .input(getKpiInputSchema)
    .output(kpiDetailSchema);
//# sourceMappingURL=get-kpi.contract.js.map